/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('wasapi/conversations', { accountScoped: true });
  }

  list(conversationId) {
    return axios.get(`${this.url}/${conversationId}/scheduled_messages`);
  }

  create(conversationId, payload) {
    return axios.post(`${this.url}/${conversationId}/scheduled_messages`, {
      scheduled_message: payload,
    });
  }

  update(conversationId, id, payload) {
    return axios.patch(
      `${this.url}/${conversationId}/scheduled_messages/${id}`,
      { scheduled_message: payload }
    );
  }

  cancel(conversationId, id) {
    return axios.delete(
      `${this.url}/${conversationId}/scheduled_messages/${id}`
    );
  }
}

export default new ScheduledMessagesAPI();
